<!-- eslint-disable -->
<template lang="pug">
    .messages-banner
        .messages-banner__header
            | {{ $i18n.t('dashboard.dashboard_messages_header') }}
        divider.messages-banner__divider(:margin="'0 auto'")
        .messages-banner__body(v-if="!isLoading")
            template(v-if="conversations.length > 0")
                div(
                    v-for="conversation in conversations"
                    :key="conversation.id"
                )
                    message(:conversation="conversation")
                    divider(:margin="'0 auto'")
            template(v-else)
                .messages-banner__empty
                    svg-icon.messages-banner__empty-icon(name="envelope")
                    | {{ $i18n.t('dashboard.dashboard_messages_noMessages') }}
                divider(:margin="'0 auto'")
        cs-loader(v-else="")
        .messages-banner__footer
            cs-button(color="blue", @click="showMessageModal = true")
                | {{ $i18n.t('dashboard.dashboard_messages_create') }}
        create-message-modal(
            v-if="showMessageModal"
            @close="showMessageModal = false"
            @send="sendMessage"
        )
</template>

<script>
    /*eslint-disable*/
    import ConversationApi from '../../../api/communication/conversation';

    import CreateMessageModal from '../../../modals/CreateMessageModal.vue';
    import Message from '../../communication/Message.vue'

    import SendMessageMixin from '../../../utils/communication/sendMessageMixin';
    import receiveMessage from '../../../utils/communication/receiveMessage';

    import moment from 'moment';
    import {mapState} from 'vuex';

    export default {
        data() {
            return {
                isLoading: false,
                conversations: [],
                showMessageModal: false,
                amount: 3
            };
        },
        mixins: [SendMessageMixin, receiveMessage],
        methods: {
            fetchData() {
                this.isLoading = true;
                ConversationApi.list({amount: this.amount})
                .then(data => {
                    this.conversations = data.data;
                    this.isLoading = false;
                })
                .catch(error => {
                    this.isLoading = false;
                    this.$toasted.error(this.$root.$t('errors.getting_data'));
                });
            }
        },
        mounted() {
            this.fetchData();
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
        },
        components: {
            CreateMessageModal,
            Message
        }
    }
</script>

<style lang="scss" scoped>
    .messages-banner {
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .messages-banner__header {
        margin: 30px 0 25px 30px;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
    }

    .messages-banner__body {
        margin: 0 30px;
        font-size: 16px;
        line-height: 24px;
    }

    .messages-banner__footer {
        margin: 30px 0 30px 30px;
    }

    .messages-banner__divider {
        width: calc(100% - 60px) !important;
    }

    .messages-banner__empty {
        display: flex;
        flex-direction: column;

        align-items: center;

        margin: 20px 0;

        font-size: 16px;
        line-height: 19px;
    }

    .messages-banner__empty-icon {
        color: $hsl-color-gray-74;
        font-size: 30px;
        padding-bottom: 10px;
    }
</style>
